<template>
  <block-blank-form
    submit-label="Добавить подъезд"
    :block="block"
    :errors="errors"
    form-type="add"
    @submit="processBlockForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addBlock } from '@/services/block.service'
import blockBlankForm from '@/components/forms/block/BlockBlankForm'

export default {
  name: 'block-add-form',
  components: { blockBlankForm },
  props: {
    building: {
      type: [Number]
    }
  },
  data () {
    return {
      block: {
        id: null,
        number: '',
        building: this.building
      },

      errors: {
        block: {
          id: [],
          number: [],
          building: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processBlockForm () {
      this.addBlock().then((success) => {
        if (success) {
          this.showMsg('Подъезд был успешно добавлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addBlock () {
      return addBlock(this.block).then((response) => {
        this.block = response.data
        this.fillErrors(this.errors.block, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.block, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BlockAddForm.vue?0a44768a